export default "__VITE_ASSET__CQLc2oIX__"